// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "bd9c2945",
    "hash": "bd9c2945",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "bd9c2945",
    "semverString": null,
    "version": "2026.6.0.13"
};
/* tslint:enable */
